import React, { useMemo } from 'react';
import { usePopulatedMeeting__INTERNAL_USE_ONLY } from './data';
import { MeetingUtilsContext } from './context';
import { LoadingView } from '../../components/utils/LoadingView';
import { useMeetingContainerContext } from '../meetingContainer/context';

export type MeetingUtilsProviderProps = {
  children: React.ReactNode;
};

export const MeetingUtilsProvider: React.FC<MeetingUtilsProviderProps> = ({
  children,
}) => {
  const containerCtx = useMeetingContainerContext();
  
  const populated = usePopulatedMeeting__INTERNAL_USE_ONLY(containerCtx.containerAPI);

  const utils = useMemo(() => (populated ? {
    populated,
    containerAPI: containerCtx.containerAPI,
  } : undefined), [containerCtx.containerAPI, populated]);

  (window as any).meetingUtils = utils;

  // Store data not ready yey,
  // could not build utils
  if (!utils) {
    return <LoadingView message="Chargement en cours ..." fullscreen />;
  }

  return (
    <MeetingUtilsContext.Provider value={utils}>
      {children}
    </MeetingUtilsContext.Provider>
  );
};
